import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import axios from 'axios';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { base_url } from "../utils/axiosConfig";

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
      }
    }
  ]
};


  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setIsLoading(true);
        const res = await axios.get(`${base_url}/master/getbanner`);
        // Adjust based on actual API response structure
        const bannerData = res.data[0]?.images || [];
        setBanners(bannerData);
      } catch (error) {
        console.error('Error fetching banner images:', error);
        setError('Failed to load banners. Please try again later.');
      } finally {
        setIsLoading(false);
      }
    };

    fetchBanners();
  }, []);

  // Fallback images for error or empty state
  const fallbackImages = [
    '/images/fallback-banner1.jpg',
    '/images/fallback-banner2.jpg',
  ];

  return (
    <section className="py-2">
      <div>
        {isLoading ? (
          <div className="text-center">Loading banners...</div>
        ) : error ? (
          <div className="text-center text-danger">{error}</div>
        ) : banners.length === 0 ? (
          <Slider {...settings}>
            {fallbackImages.map((img, index) => (
              <div className="main-banner position-relative" key={`fallback-${index}`}>
                <img
                  src={img}
                  alt={`fallback-banner-${index + 1}`}
                  className="img-fluid w-100"
                  style={{ height: '300px', objectFit: 'contain' }}
                />
              </div>
            ))}
          </Slider>
        ) : (
          <Slider {...settings}>
            {banners.map((img, index) => (
              <div className="main-banner position-relative" key={img._id || `banner-${index}`}>
                <img
                  src={`${base_url}/${img.url}`}
                  alt={`banner-${index + 1}`}
                  className="img-fluid w-100"
                  style={{ height: '100%', objectFit: 'cover' }}
                  onError={(e) => {
                    e.target.src = fallbackImages[index % fallbackImages.length];
                  }}
                />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default BannerSlider;